import { useState, useEffect } from 'react'
import { priceRangeCoversBike } from 'src/utils/insurance'

import { fetchProductInsurance } from '../../ProductAction/BuyButton/hooks/usefetchProductInsurance'
import storeConfig from '../../../../../../../../store.config'

// ID do produto de seguro
const INSURANCE_ID = storeConfig.InsuranceID

/**
 * Hook para buscar e calcular o preço mínimo do seguro disponível para uma bike
 * @param bikePrice - Preço da bike em reais
 * @param enabled - Se a busca deve ser feita (ex: apenas se for uma bike)
 * @returns O menor preço disponível do seguro ou null
 */
export function useInsurancePrice(bikePrice: number, enabled = true) {
  const [insurancePrice, setInsurancePrice] = useState<number | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!enabled) {
      return
    }

    async function fetchInsuranceData() {
      setIsLoading(true)

      try {
        const data = await fetchProductInsurance({
          productIds: INSURANCE_ID,
        })

        // Filtra os seguros válidos para o preço da bike
        const validInsurances = data
          .flatMap((insuranceProduct) => insuranceProduct?.items ?? [])
          .filter((item: { referenceId: string }) =>
            priceRangeCoversBike(item?.referenceId, bikePrice)
          )

        // Pega o menor preço disponível
        if (validInsurances && validInsurances.length > 0) {
          const minPrice = Math.min(
            ...validInsurances.map(
              (item: { offer?: { price: number } }) => item.offer?.price ?? 0
            )
          )

          setInsurancePrice(minPrice)
        }
      } catch (error) {
        console.error('Erro ao buscar preço do seguro:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchInsuranceData()
  }, [enabled, bikePrice])

  return { insurancePrice, isLoading }
}
